import { PropsWithChildren } from 'react';
import { DialogProvider } from '@/contexts/DialogContext';
import { SnackbarProvider } from '@/contexts/SnackbarContext';
import { BottomSheetIframeProvider } from '@/contexts/BottomSheetIframeContext';
import { BottomSheetProvider } from '@/contexts/BottomSheetContext';
import { ProfileCardModalProvider } from '@/contexts/ProfileCardModalContext';
import { PhoneBillDialogProvider } from '@/contexts/PhoneBillDialogContext';

export const GlobalToolsProvider = ({ children }: PropsWithChildren) => {
  return (
    <DialogProvider>
      <SnackbarProvider>
        <BottomSheetIframeProvider>
          <BottomSheetProvider>
            <ProfileCardModalProvider>
              <PhoneBillDialogProvider>{children}</PhoneBillDialogProvider>
            </ProfileCardModalProvider>
          </BottomSheetProvider>
        </BottomSheetIframeProvider>
      </SnackbarProvider>
    </DialogProvider>
  );
};
